import { postRequestNoLoading } from 'utils/http';
import { BACKEND_API } from 'global/environment';
import { CommonService } from './CommonService';

const baseURL = BACKEND_API;


const convertData = function (data) {
  const result = CommonService.findGetParameter();
  delete result['a'];
  delete result['tab'];

  const user_ip = '';
  const user_network = '';
  const user_id = '';
  const os = '';
  const referer = '';
  const device_id = '';

  const param = {
    ...result,
    ...data,
    mobile: localStorage.getItem('mobile'),
    campaign_content: '',
    campaign_desc: '',
    service: 'MYVNPT',
    user_agent: navigator.userAgent,
    user_ip,
    user_network,
    os,
    user_id,
    clicktime: Date.now(),
    referer,
    device_id
  }

  return {
    input_log: JSON.stringify(param)
  }
};

export const LogService = {
  campaignLog: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_campaign_action_log`;
    return postRequestNoLoading(URL, data, {}, successCallback, failCallback);
  },

  shortLinkLog: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_shortlink_log`;
    const convertedData = convertData(data);
    return postRequestNoLoading(URL, convertedData, {}, successCallback, failCallback);
  },

  logAccessWeb: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/log_access_web`;
    return postRequestNoLoading(URL, data, {}, successCallback, failCallback);
  },

};

